import { useState } from 'react';

import { GridColDef } from '@mui/x-data-grid';

import { TransactionOperationTableColumnKey } from '../types/TransactionOperationTable';
import { useTranslation } from '../../../../../hooks';
import { translatePrefix } from '../..';
import { useGenGridCol } from '../../../../../utils/ComponentHelper';
import CopyableText from '../../../../../components/CopyableText';

const useTransactionOperationTableColumns = (): GridColDef[] => {
  const { t } = useTranslation(translatePrefix);

  const columns = [
    useGenGridCol(TransactionOperationTableColumnKey.OperationSequence, {
      minWidth: 140,
    }),
    useGenGridCol(TransactionOperationTableColumnKey.BatchID, {
      minWidth: 110,
    }),
    useGenGridCol(TransactionOperationTableColumnKey.MerchantOrderID, {
      minWidth: 200,
    }),
    useGenGridCol(TransactionOperationTableColumnKey.Version, {}),
    useGenGridCol(TransactionOperationTableColumnKey.Path, {
      minWidth: 150,
    }),
    useGenGridCol(TransactionOperationTableColumnKey.OperationType, {
      minWidth: 150,
    }),
    useGenGridCol(TransactionOperationTableColumnKey.SendingAddress, {
      minWidth: 350,
    }),
    useGenGridCol(TransactionOperationTableColumnKey.ReceivingAddress, {
      minWidth: 350,
    }),
    useGenGridCol(TransactionOperationTableColumnKey.WalletTagOfReceivingAddress, {
      minWidth: 200,
    }),
    useGenGridCol(TransactionOperationTableColumnKey.Amount, {
      minWidth: 200,
    }),
    useGenGridCol(TransactionOperationTableColumnKey.CreationTime, {
      minWidth: 200,
    }),
    useGenGridCol(TransactionOperationTableColumnKey.LastModifiedTime, {
      minWidth: 200,
    }),
  ];

  return columns;
};

export default useTransactionOperationTableColumns;
